import { put, call } from 'redux-saga/effects';
import { Types } from './actions';
import { Types as TypesInformation } from '../../getProcedureInformation/actions';
import RetirementOfPeriodRequestRepository from '../../../../repositories/RetirementOfPeriodRequestRepository';
import RetirementOfPeriodRequestDataRepository from '../../../../../data/repositories/RetirementOfPeriodRequestDataRepository';

export default function* execute(action: any): any {
  try {
    yield put({ type: Types.REGISTER_RETIREMENT_OF_PERIOD_REQUEST });
    const retirementOfPeriodRequestRepository: RetirementOfPeriodRequestRepository =
      new RetirementOfPeriodRequestDataRepository();

    const retirementOfPeriodRegisterResponse = yield call(
      retirementOfPeriodRequestRepository.register,
      {
        procedureId: action.procedureId,
        reason: action.reason,
        detail: action.detail,
        contact: action.contact,
        idDetail2: action.idDetail2,
        detail2: action.detail2,
        period: action.period,
        career: action.career
      }
    );

    if (!retirementOfPeriodRegisterResponse) {
      yield put({
        type: Types.REGISTER_RETIREMENT_OF_PERIOD_FAILURE,
        error: 'No se pudo registrar'
      });
      return;
    }

    if (retirementOfPeriodRegisterResponse?.error) {
      yield put({
        type: Types.REGISTER_RETIREMENT_OF_PERIOD_FAILURE,
        requestId: retirementOfPeriodRegisterResponse?.requestId,
        error:
          retirementOfPeriodRegisterResponse?.error ||
          'Ocurrió un error al momento de registrar los datos del trámite solicitado.'
      });
      return;
    }
    yield put({
      type: TypesInformation.GET_PROCEDURE_INFORMATION_CLEAR
    });
    yield put({
      type: Types.REGISTER_RETIREMENT_OF_PERIOD_SUCCESS,
      requestId: retirementOfPeriodRegisterResponse?.requestId
    });
  } catch (error) {
    yield put({
      type: Types.REGISTER_RETIREMENT_OF_PERIOD_FAILURE,
      error:
        'Ocurrió un error al momento de registrar los datos del trámite solicitado.'
    });
  }
}
